export default __webpack_public_path__ + "static/media/sneaker blue.60ad1c7a.png";